import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { Button, Checkbox, Spinner } from '@fluentui/react-components';
import { IMilestoneListActionItemProps, MilestoneActionType } from '../Interfaces';
import LoadingErrorMessage from '../../../common/errorContent/LoadingErrorMessage';
import SIGNOFF_MILESTONE_MUTATION from '../../../../utils/statApi/MilestoneApi';
import milestoneListItemActionWrapper from '../processStyles';

const buttonSpinnerStyles = { marginRight: 5 };

const isAttestingText = 'Saving the attestation';

const MilestoneSignoffAction = ({
  milestone,
  submit,
}: IMilestoneListActionItemProps): JSX.Element => {
  const [isChecked, setIsChecked] = useState(false);

  const [updateMilestone, { loading, error }] = useMutation(SIGNOFF_MILESTONE_MUTATION, {
    onCompleted: () => {
      submit(MilestoneActionType.normal);
    },
  });

  const submitMilestoneAction = (): void => {
    updateMilestone({ variables: { milestoneId: milestone.id } });
  };

  return (
    <Stack horizontalAlign="center">
      <LoadingErrorMessage error={error} loading={loading} actionName={isAttestingText} />
      <StackItem className={milestoneListItemActionWrapper}>
        <Checkbox
          checked={isChecked}
          label={milestone.attestationText}
          onChange={(): void => {
            setIsChecked(!isChecked);
          }}
        />
      </StackItem>
      <Button appearance="primary" onClick={submitMilestoneAction} disabled={loading || !isChecked}>
        {loading && <Spinner size="tiny" style={buttonSpinnerStyles} aria-label="Loading" />}
        Submit
      </Button>
    </Stack>
  );
};

export default MilestoneSignoffAction;
